import { rideshareBaseApi } from "./rideshareBaseApi";

export const rideShareDashboardSlice = rideshareBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRideShareDashboardSummary: builder.query({
      query: () => "/dashboard/summary",
    }),
  }),
});

export const { useGetRideShareDashboardSummaryQuery } = rideShareDashboardSlice;
